import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  pricingInput: {
    width: '457px !important',
  },
  pricingInputsContainer: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  pricingContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  marginBottom: {
    marginBottom: '16px',
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  subContainer: {
    display: 'flex',
    gap: theme.spacing(4),
    flexDirection: 'column',
    width: '100%',
  },
}))
